import React from "react";

const Page = ({ header, footer, children, ...props }) => (
  <div {...props}>
    {header}
    {children}
    {footer}
  </div>
);

export default Page;
